import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */

/**
 * Entrypoint for plain website. This file is only loaded if the visitor needs to accept cookies.
 */
import { render } from "react-dom";
import { WebsiteBanner } from "./components";
import { getOtherOptionsFromWindow, ensureBodyElement } from "./utils";
import { listenPresetOptIn, deleteCookiesServer, getCookieConsentManager } from "./others";
import { tcfCmpApi } from "./tcf";
import * as API from "./api";
import { getWebpackPublicPath } from "@devowl-wp/utils";
import { printConsentUuidsToHTMLElement } from "@devowl-wp/cookie-consent-web-client";
import { OPT_OUT_EVENT, ready } from "@devowl-wp/cookie-consent-web-client";
import { getSsrPoweredByLink } from "@devowl-wp/react-cookie-banner";
__webpack_public_path__ = getWebpackPublicPath(process.env);
listenPresetOptIn();
tcfCmpApi();
ready(function () {
  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      pageRequestUuid4 = _getOtherOptionsFromW.pageRequestUuid4;

  var poweredLink = getSsrPoweredByLink(pageRequestUuid4);
  var element = ensureBodyElement(document.getElementById(pageRequestUuid4));
  printConsentUuidsToHTMLElement(".rcb-consent-history-uuids", getCookieConsentManager());
  document.addEventListener(OPT_OUT_EVENT, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var deleteHttpCookies;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              deleteHttpCookies = _ref.detail.deleteHttpCookies;
              // Handle cookie deletion which needs to be done server-side (e. g. HTTP cookies)
              deleteHttpCookies.length && setTimeout(function () {
                return deleteCookiesServer(deleteHttpCookies);
              }, 0);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());

  if (element) {
    render(h(WebsiteBanner, {
      poweredLink: poweredLink
    }), element);
  }
}, "interactive"); // Expose public API

if (window) {
  window.consentApi = API;
}

export * from "./api";